'use client';

import type { AppSize, PreferredAppSize } from '@repo/types/shared/app';
import { useEffect } from 'react';
import { getHost } from './host';

// This is for compatibility with the aurelia router event names
export const RouterEvent = {
    Processing: 'router:navigation:processing',
    Error: 'router:navigation:error',
    Canceled: 'router:navigation:canceled',
    Complete: 'router:navigation:complete',
    Success: 'router:navigation:success',
    ChildComplete: 'router:navigation:child:complete',
} as const;

type RouterEventType = (typeof RouterEvent)[keyof typeof RouterEvent];

export interface RouterEventNotifierProps {
    result?: RouterEventType;
    appName: string;
}

export function RouterEventNotifier({ result = RouterEvent.Success, appName }: RouterEventNotifierProps) {
    useEffect(() => {
        const size: AppSize = [window.innerWidth, window.innerHeight];
        const preferredSize: PreferredAppSize = ['auto', 'auto'];
        console.debug('RouterEventNotifier: notifying host', { result, size, preferredSize });

        getHost()
            .notifyRouterEvent(result, appName, size, preferredSize)
            .catch((err: Error) => console.warn('RouterEvent notify failed:', err));
    }, [result, appName]);

    return null;
}
